// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2FdEo","colMin":"styles_colMin__3_UuC","colCheckbox":"styles_colCheckbox__2WcgN"};